<ng-container *mobxAutorun>
  <ion-row class="ion-align-items-center ion-justify-content-between">
    <ion-row class="filters-container">
      <ion-label *ngIf="dialogView" class="ion-margin-bottom">
        {{ 'components.analyticsHeader.labels.dates' | translate }}
      </ion-label>

      <date-input label="startText" [value]="start" (ionChangeDate)="start = $event; didChange()">
      </date-input>
      <date-input label="endText" [value]="end" (ionChangeDate)="end = $event; didChange()">
      </date-input>

      <ion-label *ngIf="dialogView" class="ion-margin-bottom">
        {{ 'components.analyticsHeader.labels.filters' | translate }}
      </ion-label>

      <ns-select
        [formattingFunc]="formatFilterBy"
        [items]="viewOptions"
        [value]="filterBy"
        [enableSearch]="false"
        [showClear]="false"
        label="filterByText"
        (ionChange)="filterBy = $event; didChange()"
        class="ion-margin-horizontal"
      >
      </ns-select>

      <ns-select
        [items]="services"
        [value]="socials"
        [showClear]="false"
        [closeOnSelect]="false"
        [enableSearch]="false"
        label="socialNetworkText"
        placeholder="components.analyticsHeader.social.options.all"
        (ionChange)="socials = $event; didChange()"
      >
      </ns-select>

      <ion-row *ngIf="dialogView && filterBy === 'organization'" class="stretch-x">
        <ns-select
          *ngIf="teams"
          [items]="teams"
          [value]="selectedTeams"
          [showClear]="false"
          [closeOnSelect]="false"
          label="teamsText"
          placeholder="allTeamsText"
          (ionChange)="selectedTeams = $event; didChange()"
        >
        </ns-select>
      </ion-row>
      <ion-row class="ion-margin-start checkbox-container ion-align-self-center">
        <ion-checkbox
          color="success"
          class="ion-margin-end"
          [(ngModel)]="compareResults"
          (ionChange)="didChange()"
        >
        </ion-checkbox>
        {{ 'components.analyticsHeader.labels.compare' | translate }}
      </ion-row>
    </ion-row>
    <ion-button class="filter-button" (click)="filterResults()" *ngIf="!emitOnChange">
      {{ 'filterResultsText' | translate }}
    </ion-button>
  </ion-row>
  <div class="compare-container" *ngIf="compareResults">
    <ion-text>
      <h6>
        {{ 'components.analyticsHeader.labels.compare' | translate }}
      </h6>
    </ion-text>
    <ion-row>
      <ion-item class="ion-margin-end">
        <ion-label position="stacked">
          {{ 'compareToText' | translate }}
        </ion-label>
        <ion-select
          [interfaceOptions]="{ size: 'auto', alignment: 'start' }"
          (ionChange)="comparison = $any($event).detail.value; didChange()"
          [value]="comparison"
        >
          <ion-select-option [value]="value" *ngFor="let value of comparisonOptions">
            {{ 'components.analyticsHeader.comparison.options.' + value | translate }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <date-input
        label="startText"
        [value]="(comparison === 'custom' ? startCompareCustom : startCompare)!"
        [disabled]="comparison !== 'custom'"
        (ionChangeDate)="startCompareCustom = $event; didChange()"
      >
      </date-input>
      <date-input
        label="endText"
        [value]="(comparison === 'custom' ? endCompareCustom : endCompare)!"
        [disabled]="true"
      >
      </date-input>
    </ion-row>
  </div>
  <ion-row class="filters-container">
    <ng-content></ng-content>
  </ion-row>
</ng-container>
